/**
 * TicketsLauncher — blue Inbox icon that sits next to KoltCafe in Navbar.
 * Visible only to @koltprinting.com staff. Routes to /tickets.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { isStaff } from "../lib/access";

export default function TicketsLauncher() {
  const { user } = useAuth();
  const [openCount, setOpenCount] = useState(0);
  const [attention, setAttention] = useState(0);
  const staff = isStaff(user);

  useEffect(() => {
    if (!staff) return undefined;
    let cancel = false;
    const load = () => {
      api.get("/tickets/stats")
        .then(({ data }) => {
          if (cancel) return;
          const open = (data.by_status?.new || 0) + (data.by_status?.open || 0) + (data.by_status?.pending || 0);
          setAttention(data.attention || 0);
          setOpenCount(open);
        })
        .catch(() => {});
    };
    load();
    const t = setInterval(load, 10_000);
    return () => { cancel = true; clearInterval(t); };
  }, [staff]);

  if (!staff) return null;

  const hot = attention > 0;
  return (
    <Link
      to="/tickets"
      data-testid="kolt-tickets-launcher"
      data-state={hot ? "hot" : "idle"}
      title={hot ? `${attention} ticket${attention === 1 ? "" : "s"} need attention` : "Kolt Tickets — staff support desk"}
      className={`group inline-flex items-center gap-2 px-3 py-2 text-white rounded-sm transition-colors ${hot ? "bg-[#B91C1C] hover:bg-[#991B1B]" : "bg-[#082F4F] hover:bg-[#0B3D69]"}`}
    >
      <span className={`relative inline-flex ${hot ? "animate-heartbeat" : ""}`}>
        <Inbox className={`w-[18px] h-[18px] ${hot ? "text-white" : "text-[#7ABFFF]"}`} />
        {hot && <span className="absolute -inset-1 rounded-full bg-red-400/40 animate-ping" aria-hidden />}
      </span>
      <span className="font-mono text-[10px] tracking-[0.2em] uppercase font-bold hidden sm:inline">Tickets</span>
      {hot ? (
        <span className="ml-1 bg-white text-[#B91C1C] text-[10px] font-mono font-black px-1.5 py-0.5 rounded-full min-w-[18px] text-center" data-testid="kolt-tickets-attention">
          {attention > 99 ? "99+" : attention}
        </span>
      ) : openCount > 0 ? (
        <span className="ml-1 bg-[#1E6FB8] text-white text-[10px] font-mono font-black px-1.5 py-0.5 rounded-full min-w-[18px] text-center" data-testid="kolt-tickets-badge">
          {openCount > 99 ? "99+" : openCount}
        </span>
      ) : null}
    </Link>
  );
}
